<template>
  <div>
    <ViewSitterReservationComponent
      v-if="signalReady"
    ></ViewSitterReservationComponent>
    <div class="container" v-else>
      <h3 class="text-center">Preparing connection...</h3>
      <p class="text-muted">
        if this takes too long, it could be your network provider has a proxy or
        firewall preventing chat to be established, or use a different browser
        for this session as we have seen some features being blocked on old
        Safari and Internet Explorer. Alternatively
        <a href="https://www.dupaws.com/contact-support"> contact support </a>
        if the issue persist.
      </p>
    </div>
  </div>
</template>

<script>
import ViewSitterReservationComponent from "./ViewSitterReservationComponent";
import store from "../../../data/store";

export default {
  data() {
    return {};
  },
  components: {
    ViewSitterReservationComponent,
  },
  computed: {
    signalReady: function () {
      if (store.getters.SignalRHub != null)
        if (store.getters.SignalRHub.connection != null) return true;
      return false;
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// ViewSitterReservation.vue?ede8f1e4